import api from "../configs/axiosConfig";

export async function registerUser(payload) {
  const response = await api.post("/auth/signup", payload);
  return response.data;
}

export async function loginUser(payload) {
  const response = await api.post("/auth/login", payload);
  return response.data;
}

export const checkUsername = (username, name) =>
  api.get("/auth/check-username", {
    params: { username, name },
});